import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10d43e0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-upload" }
const _hoisted_2 = { class: "flex justify-content-between align-items-center flex-1 gap-2" }
const _hoisted_3 = { class: "flex gap-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex flex-wrap p-0 sm:p-5 gap-5" }
const _hoisted_6 = { class: "flex flex-row gap-2" }
const _hoisted_7 = ["alt", "src"]
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = {
  key: 0,
  class: "flex align-items-center justify-content-center flex-column"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cloud-upload border-2 border-circle p-3 text-2xl text-400 border-400" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4 mb-0" }, "Kéo thả ảnh minh chứng vào đây để tải lên", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "p-error"
}

import { computed, toRef } from "vue";
import FileUpload, { FileUploadUploadEvent } from "primevue/fileupload";
import Button from "primevue/button";
import { Attachment } from "@/models/attachment.model";
import { useField } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageUploader',
  props: {
    label: {},
    multiple: { type: Boolean, default: false },
    modelValue: {},
    name: {},
    group: {}
  },
  setup(__props: any) {

const props = __props;


// const emit = defineEmits<{
//   'update:modelValue': [modeValue: Attachment[]];
// }>();
// const ltsAttachment = computed<Attachment[]>({
//   get: () => props.modelValue,
//   set: (val) => {
//     emit('update:modelValue', val);
//   }
// });
const formatSize = (bytes: number) => {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};
const onUploaded = (event: FileUploadUploadEvent) => {
    if (event.xhr && event.xhr.responseText) {
        const response: Attachment[] = JSON.parse(event.xhr.responseText);
        if (response && response.length) {
            if (props.multiple) {
                ltsAttachment.value = [...ltsAttachment.value, ...response];
            } else {
                ltsAttachment.value = response
            }
        }
    }
}
const removeFile = (index: number, removeFileCallback: (index: number) => void) => {
    ltsAttachment.value.splice(index, 1);
    removeFileCallback(index);
}
const { errorMessage, value: ltsAttachment } = useField<Attachment[]>(toRef(props, 'name'), undefined, {
    initialValue: props.modelValue
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(FileUpload), {
      name: "files",
      url: 'https://drive.utc.edu.vn/file/upload?group=' + _ctx.group,
      multiple: _ctx.multiple,
      accept: "image/*",
      maxFileSize: 20000000,
      mode: "advanced",
      auto: "",
      onUpload: onUploaded,
      invalidFileSizeMessage: "Kích thước tập tin không được quá {1.}",
      invalidFileLimitMessage: "Chỉ cho phép tải lên tối đa {0.} tập tin",
      invalidFileTypeMessage: "Tập tin không đúng định dạng"
    }, {
      header: _withCtx(({ chooseCallback }) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.label), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Button), {
              onClick: ($event: any) => (chooseCallback()),
              icon: "pi pi-images",
              rounded: "",
              outlined: ""
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      content: _withCtx(({ removeUploadedFileCallback }) => [
        (_unref(ltsAttachment).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ltsAttachment), (file, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: file.url,
                    class: "card m-0 p-3 flex flex-row border-1 surface-border align-items-center gap-3 w-full"
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        role: "presentation",
                        alt: file.name,
                        src: file.url,
                        width: "100",
                        height: "50",
                        class: "shadow-2"
                      }, null, 8, _hoisted_7),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(file.name), 1),
                        _createElementVNode("div", null, _toDisplayString(formatSize(file.size)), 1)
                      ])
                    ]),
                    _createVNode(_unref(Button), {
                      class: "ml-auto",
                      icon: "pi pi-times",
                      onClick: ($event: any) => (removeFile(index, removeUploadedFileCallback)),
                      outlined: "",
                      rounded: "",
                      severity: "danger"
                    }, null, 8, ["onClick"])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      empty: _withCtx(() => [
        (!_unref(ltsAttachment).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["url", "multiple"]),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})